import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-model',
  templateUrl: './model.component.html',
  styleUrls: ['./model.component.css']
})
export class ModelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
